import { Injectable } from '@angular/core';
import { QuestionSetBloc } from '@kp/question-set/question-set.bloc';
import { LastReflection } from '@kp/shared/components/daily-challenge/last-reflection.model';
import { BrowserStorage, DataStoreService } from '@kservice';
import { JsonObject } from '@ktypes/models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LastReflectionBloc {
  constructor(
    private _browserStorage: BrowserStorage,
    private _dataStoreService: DataStoreService,
    private _questionSetBloc: QuestionSetBloc
  ) {}

  private _lastReflectionBehaviorSubject: BehaviorSubject<LastReflection> = new BehaviorSubject<LastReflection>(null);

  get lastReflection$(): Observable<LastReflection> {
    return this._lastReflectionBehaviorSubject.asObservable();
  }

  set setLastReflection(reflection: LastReflection) {
    const reflectionJson: JsonObject = {};
    reflectionJson[this._dataStoreService.authData.user?.id] = reflection;
    this._browserStorage.setObject('lastReflection', reflectionJson);
    this._lastReflectionBehaviorSubject.next(reflection);
  }

  refresh(): void {
    let reflection =
      this._lastReflectionBehaviorSubject.value ||
      this._browserStorage.getObject('lastReflection')?.[this._dataStoreService.authData.user?.id];

    if (reflection != null) {
      this._lastReflectionBehaviorSubject.next(reflection);
    } else {
      this._questionSetBloc.getDailyReflectionHistory();
      this._questionSetBloc.questionSetHistoryRequestSubject$.subscribe((value) => {
        const reflectionDate = value?.data?.[0]?.completedDate;
        if (value != null && value.data && value.data.length > 0 && reflectionDate) {
          reflection = new LastReflection(
            null,
            reflectionDate.getDay().toString(),
            reflectionDate.getTime().toString(),
            reflectionDate
          );

          this.setLastReflection = reflection;
        } else {
          this.setLastReflection = new LastReflection(null, null, null, null);
        }
      });
    }
  }
}
